import { lazyComponent } from '@Pages/pageRuntime/components/lazyComponent';

export const LazyFormFieldDisplay = lazyComponent(async () => ({
  default: (await import('./FieldDisplay')).FormFieldDisplay
}));
